/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetUserCards200ResponseInnerAvailableMerchantCategoriesInner } from './get-user-cards200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetUserCards200ResponseInnerReissue } from './get-user-cards200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetUserCards200ResponseInnerUser } from './get-user-cards200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetUserCards200ResponseInnerUserAccountGroup } from './get-user-cards200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetUserCards200ResponseInner
 */
export interface GetUserCards200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserCards200ResponseInner
     */
    'availableCurrencies': Array<GetUserCards200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetUserCards200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof GetUserCards200ResponseInner
     */
    'availableMerchantCategories': Array<GetUserCards200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetUserCards200ResponseInnerUser}
     * @memberof GetUserCards200ResponseInner
     */
    'user': GetUserCards200ResponseInnerUser;
    /**
     * 
     * @type {GetUserCards200ResponseInnerUserAccountGroup}
     * @memberof GetUserCards200ResponseInner
     */
    'userAccountGroup'?: GetUserCards200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserCards200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserCards200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserCards200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetUserCards200ResponseInnerReissue}
     * @memberof GetUserCards200ResponseInner
     */
    'reissue'?: GetUserCards200ResponseInnerReissue | null;
}

export const GetUserCards200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetUserCards200ResponseInnerAvailableCurrenciesEnum = typeof GetUserCards200ResponseInnerAvailableCurrenciesEnum[keyof typeof GetUserCards200ResponseInnerAvailableCurrenciesEnum];


